import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserMenuComponent } from './user-menu.component';

import { ChangeMfaDialogComponent } from '@fleet/auth/components/change-mfa-dialog/change-mfa-dialog.component';
import { ChangePhonenumberDialogModule } from '@fleet/auth/components/change-phonenumber-dialog/change-phonenumber-dialog.module';
import { ChangeUsernameDialogModule } from '@fleet/auth/components/change-username-dialog/change-username-dialog.module';
import { ChangePasswordModule } from '../change-password';

@NgModule({
  declarations: [UserMenuComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatDialogModule,
    ReactiveFormsModule,
    ChangePasswordModule,
    ChangePhonenumberDialogModule,
    ChangeUsernameDialogModule,
    ChangeMfaDialogComponent,
  ],
  exports: [UserMenuComponent],
})
export class UserMenuModule {}
